/** Build/runtime configuration. */
export const isMobile = import.meta.env.VITE_PLATFORM === "mobile";

function withSlash(url: string) {
  return url.endsWith("/") ? url : `${url}/`;
}

/** API base URL: window.__WB_CONFIG__.apiBaseUrl (mobile host) → VITE_API_BASE_URL → default. */
export function apiBaseUrl(): string {
  const runtime = typeof window !== "undefined" ? window.__WB_CONFIG__?.apiBaseUrl : undefined;
  return withSlash(
    runtime ||
      import.meta.env.VITE_API_BASE_URL ||
      (isMobile ? "https://10.0.2.2:7100/" : "https://localhost:7100/"),
  );
}

/** The portal is English only (sent as Accept-Language). */
export const culture = "en";

export const supportEmail = "support@sirlevantine.com";
export const businessName = "Sir Levantine Academy";
export const legalEntity = "Sir Levantine Limited";
